import React from "react";
import { Navigate } from "react-router-dom";
// import { useUserAuth } from "../../context/UserAuthContext";
const ProtectedRoute = ({children}) => {
  // const { user } = useUserAuth();
  const user = localStorage.getItem('phNumber');
  const isApproved = localStorage.getItem("isApproved") === "true";
  
  if (!user) {
    return <Navigate to="/" />;
  }

  if (isApproved === 'Pending') {
    return <Navigate to="/pending_approve" />;
  }

  return children;
};

export default ProtectedRoute;